/* eslint-disable operator-linebreak */

import styled from 'styled-components';

export const StyledButton = styled.button`
  height: 35px;
  text-transform: uppercase;
  outline-offset: 3px;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 10px 12px;
  cursor: pointer;
  border: none;
`;

export const RedBtn = styled(StyledButton)`
  color: #fff;
  background: var(--red);
  outline: 1px solid var(--red);
  &:hover {
    background: var(--white);
    color: var(--darkGrey);
  }
`;

export const DarkGreyBtn = styled(StyledButton)`
  color: #fff;
  background: var(--darkGrey);
  outline: 1px solid var(--red);
  &:hover {
    background: var(--white);
    color: var(--darkGrey);
  }
`;

type Props = {
  children: React.ReactNode;
  clickEvent: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const RedStandardBtn: React.FC<Props> = ({ children, clickEvent }) => (
  <RedBtn onClick={(e) => clickEvent(e)}>{children}</RedBtn>
);

export const DarkGreyStandardBtn: React.FC<Props> = ({ children, clickEvent }) => (
  <DarkGreyBtn onClick={(e) => clickEvent(e)}>{children}</DarkGreyBtn>
);
